var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import * as React from 'react';
import * as PropTypes from 'prop-types';
import { classNames } from '@progress/kendo-react-common';

var MenuItemLink = function (_super) {
  __extends(MenuItemLink, _super);

  function MenuItemLink() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * @hidden
   */


  MenuItemLink.prototype.render = function () {
    if (this.props.url) {
      return React.createElement("a", {
        className: this.getMenuItemClassName(),
        role: "presentation",
        href: this.props.url,
        tabIndex: -1
      }, this.props.children);
    } else {
      return React.createElement("span", {
        className: this.getMenuItemClassName(),
        role: "presentation"
      }, this.props.children);
    }
  };

  MenuItemLink.prototype.getMenuItemClassName = function () {
    return classNames('k-link', 'k-menu-link', {
      'k-state-active': this.props.opened
    });
  };
  /**
   * @hidden
   */


  MenuItemLink.propTypes = {
    opened: PropTypes.bool,
    url: PropTypes.string
  };
  return MenuItemLink;
}(React.Component);

export { MenuItemLink };